import { IconsId } from 'assets/font-icons-generated/icons';
import React, { CSSProperties } from 'react';
import 'assets/font-icons-generated/icons.css';

interface Props {
  icon: IconsId;
  style?: CSSProperties;
  className?: string;
  id?: string;
}

/**
 * Draws icons batched into the font file.
 * See Source/EPDServices.Web/epdportal-icons/ project for more details.
 */
const FontIcon: React.FC<Props> = ({ icon, className, ...otherProps }) => {
  return <i className={`icon icon-${icon} ${className || ''}`} {...otherProps} />;
};

export default FontIcon;
